import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  EffectRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  Signal,
  signal,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { IProcessProfile, IProfileParams, Process } from '@partners/api';
import { EnvironmentService, ProfileService } from '@partners/kernel';
import { IFlatStage } from '@partners/navigation';
import { SettingsMap, TFeature } from '@partners/settings';
import { RootStore, ShellStore } from '@partners/state';
import { TProcessId } from '@partners/types';
import { SLIDE_UP_DOWN_ANIMATION } from '@partners/ui';
import { isNotEmpty } from '@partners/utils';
import { Observable } from 'rxjs';
import { filter, map, pairwise, startWith } from 'rxjs/operators';

type TPartnerName =
  | 'cal'
  | 'cal-loan'
  | 'becal'
  | 'bit'
  | 'wix'
  | 'cibus'
  | 'bttr'
  | 'flycard'
  | 'yellow'
  | 'payme'
  | 'matalon'
  | 'carrefour'
  | 'htzone'
  | 'hitechzone-cashback'
  | 'mami'
  | 'yenotbitan'
  | 'hashkal'
  | 'shufersal'
  | 'family365'
  | 'idf'
  | 'students';
type TPartnersDic = { [key in TPartnerName]?: TPartnerByProcess };

type TPartnerByProcess = {
  [key in TProcessId]?: {
    saleOfferCode: number;
    salePointCode: number;
  };
};

interface IDebuggerModel {
  lobCode: number;
  brandCode: number;
  router: string;
  partner: string;
  token: string;
  isWebMode: boolean;
  saleOfferCode: number;
  salePointCode: number;
  triggerCode: number;
  view: string;
}

interface IModelChange {
  prev: IDebuggerModel;
  next: IDebuggerModel;
}

// type PartnersCollection = typeof TPartnerName[number];

// export const Partners = Array<keyof TPartnerName>;

@Component({
  standalone: true,
  selector: 'partners-debugger',
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    DragDropModule,
    RouterModule,
    BrowserModule,
    MatButtonToggleModule,
    ReactiveFormsModule,
    MatSelectModule,
    DragDropModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSlideToggleModule
  ],
  templateUrl: './debugger.component.html',
  styles: [
    `
      @use 'mixins' as mix;

      body .debugger,
      body[class$='-theme'] .debugger {
        display: grid;
        max-width: 23rem;
        padding: 8px;
        min-width: 20rem;
        font-size: 14px;
        position: fixed;
        z-index: 1;
        right: 1rem;
        top: 1rem;
        border-radius: 25px;
        background-color: rgba(0, 0, 0, 0.23);
        margin: 0;
        min-height: 40px;
        overflow: hidden;
        z-index: 10;
        color: #fff;
        letter-spacing: 0.0125rem;
        .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-floating-label,
        .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-floating-label--float-above {
          --mdc-filled-text-field-label-text-color: #fff;
          color: var(--mdc-filled-text-field-label-text-color);
        }
        .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
          --mdc-filled-text-field-focus-active-indicator-color: #fff;
          border-bottom-color: var(--mdc-filled-text-field-focus-active-indicator-color);
        }
        .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
          --mdc-filled-text-field-active-indicator-color: #fff;
          border-bottom-color: var(--mdc-filled-text-field-active-indicator-color);
        }
        .mdc-text-field--filled:not(.mdc-text-field--disabled) {
          background-color: transparent;
        }
        .mat-mdc-form-field-flex {
          background-color: transparent;
        }
        .mat-mdc-select-value,
        .mat-mdc-select-value-text {
          color: #fff;
          display: block;
        }
        .mat-button-toggle {
          flex: 1;
        }
        .mat-mdc-form-field-subscript-wrapper {
          min-height: 0;
          height: 0;
        }
        .mdc-label,
        .mat-mdc-select-arrow {
          color: #fff;
        }
        .mat-mdc-select-value {
          display: flex;
        }
        .mat-mdc-outlined-button,
        .mat-mdc-raised-button {
          width: 6.25rem;
          border-radius: 2rem;
          font-size: 1.2rem;

          letter-spacing: 0.01rem;
          &[disabled][disabled] {
            color: rgba(255, 255, 255, 0.45);
            border: 2px dashed rgba(255, 255, 255, 0.45);
            --mdc-protected-button-disabled-container-color: transparent;
            --mdc-protected-button-disabled-label-text-color: #fff;
          }
        }
        .mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label {
          font-size: 1.2rem;
        }
        .mat-mdc-outlined-button {
          border: 1px solid #fff;
          color: #fff;
        }
        section.toggler-container {
          div {
            width: fit-content;
          }
          div.dev-artistry-mode {
            background: teal;
            border-radius: 6px;
            padding: 1px;
            border: 2.5px solid;
          }
          .dev-view {
            font-size: 1.25rem;
            cursor: pointer;
          }
        }
        .view-toggler {
          display: grid;
          place-content: center;
          cursor: pointer;
          height: 20px;
          width: 25px;
          padding: 0;
          position: absolute;
          left: 19px;
          top: 9px;
          span {
            display: inline-block;
            font-size: 25px;
            padding: 0;
            line-height: 0.3;
            white-space: nowrap;
          }
        }
        .reset,
        .submit {
          overflow: hidden;
          display: grid;
          place-items: center;
          margin: 1.25rem 0;
        }
        form {
          max-height: 80dvh;
          height: 100%;
          overflow-y: auto;
          padding: 15px 15px 15px 10px;
          display: grid;
          grid-auto-flow: row;
          grid-template-columns: 1fr;
          grid-template-rows: auto;
          grid-gap: 0.5rem 0;
          justify-content: center;
          align-items: start;
          color: #fff;
        }
        textarea {
          height: 4rem;
          width: 100%;
          padding: 0.25rem;
          border-radius: 5px;
          background-color: #ffffff25;
          border: none;
          color: #fff;
          direction: ltr;
          text-align: left;
          &.url-textbox {
            height: 6rem;
          }
        }
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [CdkDrag],
  host: {
    class: 'debugger'
  },
  animations: [SLIDE_UP_DOWN_ANIMATION]
})
export class DebuggerComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly _sessionKey = 'DEBUGGER_MODE';

  get debuggerState() {
    return !!sessionStorage.getItem(this._sessionKey);
  }

  set debuggerState(activate: boolean) {
    if (activate) {
      sessionStorage.setItem(this._sessionKey, 'COLLAPSE');
    } else {
      sessionStorage.removeItem(this._sessionKey);
    }
  }

  readonly partnersDic: TPartnersDic = {
    cal: {
      card: { saleOfferCode: 42, salePointCode: 206 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    flycard: {
      card: { saleOfferCode: 47, salePointCode: 206 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    htzone: {
      card: { saleOfferCode: 83, salePointCode: 4797 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    'hitechzone-cashback': {
      card: { saleOfferCode: 340, salePointCode: 8000048 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    hashkal: {
      card: { saleOfferCode: 83, salePointCode: 4797 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    wix: {
      card: { saleOfferCode: 7, salePointCode: 4797 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    carrefour: {
      card: { saleOfferCode: 84, salePointCode: 177 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    bit: {
      card: { saleOfferCode: 84, salePointCode: 177 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    payme: {
      card: { saleOfferCode: 84, salePointCode: 177 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    bttr: {
      card: { saleOfferCode: 80, salePointCode: 4795 },
      loan: { saleOfferCode: 0, salePointCode: 0 }
    },
    mami: {
      card: { saleOfferCode: 107, salePointCode: 0 },
      loan: { saleOfferCode: 107, salePointCode: 0 }
    },
    yenotbitan: {
      card: { saleOfferCode: 64, salePointCode: 94 },
      loan: { saleOfferCode: 64, salePointCode: 94 }
    },
    idf: {
      card: { saleOfferCode: 64, salePointCode: 94 },
      loan: { saleOfferCode: 64, salePointCode: 94 }
    },
    students: {
      card: { saleOfferCode: 33, salePointCode: 94 },
      loan: { saleOfferCode: 33, salePointCode: 94 }
    }
  };

  readonly lobList = [
    { key: 'כרטיס', value: Process.card as number },
    { key: 'הלוואה', value: Process.loan as number },
    { key: 'BNPL', value: Process.bnpl as number }
  ];

  readonly brandList = [
    { key: 'ויזה', value: 1 },
    { key: 'דיינרס', value: 3 },
    { key: 'מסטרכארד', value: 6 },
    { key: 'דיינרס בינ"ל', value: 9 }
  ];
  readonly partnersList = [
    'bit',
    'bttr',
    'becal',
    'cal',
    'cal-loan',
    'carrefour',
    'cibus',
    'default',
    'family365',
    'flycard',
    'hando',
    'hashkal',
    'htzone',
    'hitechzone-cashback',
    'idf',
    'mami',
    'matalon',
    'paybox',
    'paylease',
    'payme',
    'powercard',
    'shufersal',
    'wix',
    'yellow',
    'yenotbitan',
    'students'
  ];

  readonly debugForm: FormGroup;

  profile$$: Signal<IProcessProfile>;
  router$: Observable<Pick<IFlatStage, 'title' | 'url' | 'name'>[]>;

  get formValue(): IDebuggerModel {
    return this.debugForm.getRawValue();
  }

  @ViewChild('autoUrlTextBox', { static: false, read: ElementRef })
  urlTextBox: ElementRef;

  @ViewChild('toggleButton', { static: false, read: ElementRef })
  toggleButton: ElementRef;

  @ViewChild('debuggerForm', { static: false })
  ngForm: NgForm;

  isCollapsed = signal<boolean>(this.debuggerState);

  #rootStore = inject(RootStore);
  #router = inject(Router);
  #changeDetector = inject(ChangeDetectorRef);
  #changeEffectRef: EffectRef;
  #shellStore = inject(ShellStore);
  #profileService = inject(ProfileService);
  #formBuilder = inject(FormBuilder);
  #change: Signal<IModelChange>;
  #urlFormat = signal<string>('');
  #envService = inject(EnvironmentService);

  readonly initialState: IProfileParams = {
    lobCode: 1,
    brandCode: 1,
    partner: 'cal',
    token: 'TOKEN',
    saleOfferCode: this.partnersDic['cal'].card.saleOfferCode,
    salePointCode: this.partnersDic['cal'].card.salePointCode,
    triggerCode: 0,
    view: 'auth-guide',
    uid: undefined,
    acMan: null
  };

  constructor() {
    // this.partnersList: ToArray<TPartnerName>;

    this.debugForm = this.#formBuilder.group({
      lobCode: new FormControl(undefined, [Validators.required]),
      brandCode: new FormControl(undefined, [Validators.required]),
      router: new FormControl(undefined),
      partner: new FormControl(undefined, [Validators.required]),
      theme: new FormControl(undefined),
      token: new FormControl(undefined, [Validators.required]),
      isWebMode: new FormControl<boolean>(undefined),
      saleOfferCode: new FormControl(undefined),
      salePointCode: new FormControl(undefined),
      triggerCode: new FormControl(undefined)
    });

    this.#change = toSignal<IModelChange>(
      this.debugForm.valueChanges.pipe(
        startWith(null),
        pairwise(),
        map(([prev, next]) => ({ prev, next }))
      )
    );

    this.#changeEffectRef = effect(
      () => {
        const modelValue = this.#change();

        if (!modelValue?.next) {
          return;
        }

        const { next }: IModelChange = this.#change();

        this.#buildUrl();

        // if (this.shouldReset()) {
        //   this.ngOnDestroy();
        //   this.resetMockProcess();
        // }
      },
      { allowSignalWrites: true }
    );

    this.router$ = this.#shellStore.flatStages$.pipe(
      filter((stages: IFlatStage[]) => !!stages?.length),
      map((stages: IFlatStage[]) => {
        const activeStages: IFlatStage[] = stages.filter((stage) => !!SettingsMap.get(stage.name as TFeature));
        return activeStages;
      }),
      map((stages: IFlatStage[]) => {
        return stages.map((stage) => ({
          name: stage.name,
          title: stage.title,
          url: SettingsMap.get(stage.name as TFeature).path
        }));
      })
    );
  }

  shouldReset(): boolean {
    const { partner, lobCode, brandCode } = this.formValue;

    const profile = this.#profileService.profile$$();

    const lostIntegrity =
      partner !== profile?.params.partner ||
      lobCode !== profile?.params.lobCode ||
      brandCode !== profile?.params.brandCode;

    return lostIntegrity;
  }

  ngOnInit(): void {
    const storedParams = this.#profileService.params$$();
    const hasStoredParams = isNotEmpty(storedParams?.lobCode);

    const initParams = hasStoredParams
      ? storedParams
      : this.#envService.isMockMode$$()
      ? this.initialState
      : Object.assign(this.initialState, { token: null });

    this.debugForm.patchValue(initParams);

    !hasStoredParams && this.#shellStore.dispatchUpdateProfileParams(this.initialState);
  }

  toggleView() {
    const nextState = !this.isCollapsed();
    this.isCollapsed.set(nextState);
  }

  togglePermanentView() {
    this.toggleView();
    this.debuggerState = this.isCollapsed();
  }

  ngAfterViewInit(): void {
    this.debugForm.updateValueAndValidity();
    this.#changeDetector.markForCheck();
  }

  ngOnDestroy(): void {
    this.#changeEffectRef.destroy();
  }

  launchApp() {
    this.#rootStore.dispatchResetState();
    const url = this.#urlFormat();
    window.location.href = url;

    // this.#profileService
    //   .createAppProfile$(url)
    //   .pipe(
    //     takeOnce(),
    //     tap(() => this.#changeDetector.detectChanges())
    //   )
    //   .subscribe();
  }

  navigate({ value }: MatSelectChange) {
    this.#router.navigateByUrl(value);
  }

  resetMockProcess() {
    this.ngForm.resetForm();
    this.#rootStore.dispatchResetState();
    const url = new URL(window.location.href);
    // window.location.href = url.origin;
    this.#router.navigateByUrl('');
  }

  #buildUrl() {
    const queryString = this.#buildUrlQuery();

    const fullUrl = `${window.location.href}?${queryString}`;

    this.#urlFormat.set(fullUrl);
  }

  #buildUrlQuery(): string {
    const { lobCode, partner, theme, isWebMode, token, brandCode, saleOfferCode, salePointCode, recommenderId } =
      this.debugForm.getRawValue();

    const mode = isWebMode ? `uid=${token}` : `token=${token}`;
    //const view = isWebMode ? 'introduction' : 'auth-guide';
    const isLoan = lobCode === 2;
    let view = null;
    if (isWebMode) {
      view = isLoan ? 'classify' : 'introduction';
    } else {
      view = 'auth-guide';
    }

    // return `${mode}&saleOfferCode=${saleOfferCode}&salePointCode=${salePointCode}&brandCode=${brandCode}&partner=${partner}&lobCode=${lobCode}&view=${view}&triggerCode=0`;
    return `${mode}&partner=${partner}&theme=${theme}&saleOfferCode=${saleOfferCode}&salePointCode=${salePointCode}&brandCode=${brandCode}&lobCode=${lobCode}&view=${view}&recommenderId=${recommenderId}`;
  }
}
